<template>
  <div>
    <div
      v-for="item in items"
      :key="item.id"
      :class="{
        [`element_lvl_${level}`]: true,
        'plan-limits-warning__rules': level === 0 && item.hasPlanLimitsRestriction,
      }"
    >
      <ui-tooltip-icon
        class="plan-limits-warning__tooltip"
        preset="error"
        v-if="level === 0 && item.hasPlanLimitsRestriction"
        :text="
          t(
            'This option is no longer active due to the subscription change to the plan which doesn’t include this option or this add-on is switched off in your subscriptions settings.',
          )
        "
      ></ui-tooltip-icon>
      <button
        class="main-row"
        v-if="item.children && item.children.length"
        type="button"
        @click="clickMainRow(item)"
      >
        <ui-icon
          size="15"
          :color="$colors.gray40"
          :icon="`fa ${isOpened(item) ? 'fa-caret-down' : 'fa-caret-right'}`"
          class="main-row__icon"
        ></ui-icon>
        <slot :item="item"></slot>
      </button>
      <div class="main-row" v-else>
        <slot :item="item"></slot>
      </div>
      <div v-if="item.children && item.children.length && isOpened(item)" class="children">
        <ui-treeview :items="item.children" :level="level + 1" :isAllOpened="isAllOpened">
          <template v-for="(_, slotName) in slots" #[slotName]="slotData">
            <slot :name="slotName" v-bind="slotData || {}" />
          </template>
        </ui-treeview>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, useSlots } from 'vue';
import { useColors, useI18n } from '@/composables';

const props = withDefaults(
  defineProps<{
    isAllOpened?: boolean;
    level?: number;
    items?: TreeViewItem[];
  }>(),
  {
    isAllOpened: true,
    level: 0,
    items: () => [],
  },
);

const { t } = useI18n();
const $colors = useColors();
const slots = useSlots();

const isChildOpened = ref<Record<string, boolean>>({});

const isOpened = (item: TreeViewItem) =>
  props.isAllOpened ? !isChildOpened.value[item.id] : isChildOpened.value[item.id];

const clickMainRow = (item: TreeViewItem) => {
  isChildOpened.value[item.id] = !isChildOpened.value[item.id];
};
</script>

<style lang="scss" scoped>
.main-row {
  min-height: 34px;
  display: flex;
  align-items: center;
  width: 100%;
}

.main-row__icon {
  margin-right: 6px;
  width: 10px;
}

.children {
  margin-left: 26px;
}

.last-child {
  margin-left: 50px;
}

.element_lvl_0 {
  margin-bottom: 10px;
}

.plan-limits-warning__rules {
  position: relative;
  z-index: 1;
  &:before {
    position: absolute;
    display: block;
    content: '';
    border: 1px solid var(--color-red);
    top: 0;
    bottom: 0;
    left: -5px;
    right: -5px;
    z-index: -1;
  }
}

.plan-limits-warning__tooltip {
  right: 4px;
}
</style>
